import _defineProperty from "/var/jenkins_home/workspace/tingle.e49e9adf-d3ea-4dee-b9a2-f3d0e4982b89/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/var/jenkins_home/workspace/tingle.e49e9adf-d3ea-4dee-b9a2-f3d0e4982b89/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["name", "className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// ignore-string-externalization
import React from 'react';
import cs from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function Icon(_ref) {
  var name = _ref.name,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  var svgProps = _objectSpread(_objectSpread({}, props), {}, {
    className: cs("svg-".concat(name), className)
  });

  switch (name) {
    case 'facebook-icon':
      return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, svgProps), {}, {
        viewBox: "0 0 448 448",
        children: /*#__PURE__*/_jsx("path", {
          d: "m119.75 242.25v-74h63.75v-54.5q0-46.5 26-72.125t69.25-25.625q36.75 0 57 3v66h-39.25q-21.5 0-29 9t-7.5 27v47.25h73.25l-9.75 74h-63.5v189.75h-76.5v-189.75h-63.75z"
        })
      }));

    case 'twitter-icon':
      return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, svgProps), {}, {
        viewBox: "0 0 448 448",
        children: /*#__PURE__*/_jsx("path", {
          d: "m27 347.75q8.75 1 19.5 1 56.25 0 100.25-34.5-26.25-0.5-47-16.125t-28.5-39.875q8.25 1.25 15.25 1.25 10.75 0 21.25-2.75-28-5.75-46.375-27.875t-18.375-51.375v-1q17 9.5 36.5 10.25-16.5-11-26.25-28.75t-9.75-38.5q0-22 11-40.75 30.25 37.25 73.625 59.625t92.875 24.875q-2-9.5-2-18.5 0-33.5 23.625-57.125t57.125-23.625q35 0 59 25.5 27.25-5.25 51.25-19.5-9.25 28.75-35.5 44.5 23.25-2.5 46.5-12.5-16.75 24.5-40.5 41.75 0.25 3.5 0.25 10.5 0 32.5-9.5 64.875t-28.875 62.125-46.125 52.625-64.5 36.5-80.75 13.625q-67.75 0-124-36.25z"
        })
      }));

    case 'instagram-icon':
      return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, svgProps), {}, {
        viewBox: "0 0 448 448",
        children: /*#__PURE__*/_jsx("path", {
          d: "m32 366.75v-285.5q0-20.25 14.5-34.75t34.75-14.5h285.5q20.25 0 34.75 14.5t14.5 34.75v285.5q0 20.25-14.5 34.75t-34.75 14.5h-285.5q-20.25 0-34.75-14.5t-14.5-34.75zm42.749-10.25q0 6.5 4.375 10.875t10.875 4.375h267.25q6.25 0 10.75-4.375t4.5-10.875v-162h-33.75q5 15.75 5 32.75 0 31.5-16 58.125t-43.5 42.125-60 15.5q-49.25 0-84.25-33.875t-35-81.875q0-17 5-32.75h-35.25v162zm72.501-133.25q0 31 22.625 52.875t54.375 21.875q32 0 54.625-21.875t22.625-52.875-22.625-52.875-54.625-21.875q-31.75 0-54.375 21.875t-22.625 52.875zm147.25-90q0 7.25 5 12.25t12.25 5h43.5q7.25 0 12.25-5t5-12.25v-41.25q0-7-5-12.125t-12.25-5.125h-43.5q-7.25 0-12.25 5.125t-5 12.125v41.25z"
        })
      }));

    case 'chevron-down':
      return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, svgProps), {}, {
        viewBox: "0 0 1024 1024",
        children: /*#__PURE__*/_jsx("path", {
          className: "path1",
          d: "M476.455 806.696l-381.164-381.164q-14.621-14.621-14.621-35.293t14.621-34.789 35.293-14.117 34.789 14.117l342.846 343.35 349.4-349.4q14.621-14.117 35.293-14.117t34.789 14.117 14.117 34.789-14.117 34.789l-381.164 381.164q-19.159 19.159-38.318 19.159t-31.764-12.605z"
        })
      }));

    case 'scroll-down':
      return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, svgProps), {}, {
        viewBox: "643.5 386 22.1 21.9",
        children: [/*#__PURE__*/_jsx("path", {
          d: "M665.6,396.3c0,0.3-0.1,0.7-0.4,0.9l-9.8,10.4c-0.5,0.5-1.3,0.5-1.7,0l-9.8-10.4c-0.5-0.5-0.5-1.3,0-1.8 s1.3-0.5,1.7,0l8.9,9.5l8.9-9.5c0.5-0.5,1.3-0.5,1.7,0C665.5,395.6,665.6,396,665.6,396.3z"
        }), /*#__PURE__*/_jsx("path", {
          d: "M665.6,387.3c0,0.3-0.1,0.7-0.4,0.9l-9.8,10.4c-0.5,0.5-1.3,0.5-1.7,0l-9.8-10.4c-0.5-0.5-0.5-1.3,0-1.8 s1.3-0.5,1.7,0l8.9,9.5l8.9-9.5c0.5-0.5,1.3-0.5,1.7,0C665.5,386.6,665.6,387,665.6,387.3z"
        })]
      }));

    case 'music':
      return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, svgProps), {}, {
        viewBox: "0 0 119 119",
        children: [/*#__PURE__*/_jsx("circle", {
          fill: "none",
          stroke: "#4C99F8",
          strokeWidth: "4",
          cx: "59.5",
          cy: "59.5",
          r: "57.5"
        }), /*#__PURE__*/_jsx("path", {
          d: "M385.58,294.09v23.58A8,8,0,1,0,378.91,331a6.93,6.93,0,0,0,1.64,0,8,8,0,0,0,7.16-7.92V295.8l6.54-1.39v-2.17Zm-5.85,34.81a5.84,5.84,0,1,1,5.85-5.84A5.85,5.85,0,0,1,379.73,328.9Z",
          transform: "translate(-336 -246)"
        }), /*#__PURE__*/_jsx("path", {
          d: "M404.25,290.13v2.17l7.9-1.67v21.77a7.94,7.94,0,1,0,2.13,5.39V288Zm2,33.49a5.84,5.84,0,1,1,5.85-5.83A5.85,5.85,0,0,1,406.3,323.62Z",
          transform: "translate(-336 -246)"
        }), /*#__PURE__*/_jsx("polygon", {
          points: "63.15 29.5 57 36.69 62.13 36.69 62.13 53.59 64.18 53.59 64.18 36.69 69.3 36.69 63.15 29.5"
        })]
      }));

    case 'connect':
      return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, svgProps), {}, {
        viewBox: "0 0 119 119",
        children: [/*#__PURE__*/_jsx("path", {
          d: "M59.5,0A59.5,59.5,0,1,0,119,59.5,59.57,59.57,0,0,0,59.5,0Zm0,115A55.5,55.5,0,1,1,115,59.5,55.56,55.56,0,0,1,59.5,115Z"
        }), /*#__PURE__*/_jsx("path", {
          d: "M83,37.62A11.5,11.5,0,1,0,61.29,43L46.64,53.25a11.57,11.57,0,1,0,0,13L61.28,76.5a11.49,11.49,0,1,0,11.18-6.15V49.14A11.55,11.55,0,0,0,83,37.62ZM37.13,69.31a9.56,9.56,0,1,1,9.5-9.56A9.54,9.54,0,0,1,37.13,69.31ZM47.6,64.5a11.5,11.5,0,0,0,0-9.49L62.37,44.68a11.47,11.47,0,0,0,8.09,4.45V70.35a11.47,11.47,0,0,0-8.1,4.47ZM81,81.86a9.5,9.5,0,1,1-9.5-9.56A9.54,9.54,0,0,1,81,81.86Zm-9.5-34.67A9.56,9.56,0,1,1,81,37.62,9.54,9.54,0,0,1,71.46,47.19Z"
        }), /*#__PURE__*/_jsx("path", {
          d: "M40.66,61.58l-1.76-1.06,0.72-.84a3.29,3.29,0,0,0,.78-2.13V57.27a3.3,3.3,0,0,0-1-2.39A3.22,3.22,0,0,0,36.92,54a3.33,3.33,0,0,0-3,3.36v0.18a3.29,3.29,0,0,0,.78,2.13l0.71,0.88-1.76,1A3.29,3.29,0,0,0,32,64.43V65.5h1V64.43a2.24,2.24,0,0,1,1.12-1.94l1.76-1a1.08,1.08,0,0,0,.28-1.63L35.45,59a2.23,2.23,0,0,1-.53-1.45V57.37A2.27,2.27,0,0,1,37,55.05a2.18,2.18,0,0,1,1.66.6,2.21,2.21,0,0,1,.7,1.62v0.28A2.23,2.23,0,0,1,38.81,59l-0.72.85a1.08,1.08,0,0,0,.28,1.63l1.76,1a2.24,2.24,0,0,1,1.12,1.94V65.5h1V64.43A3.28,3.28,0,0,0,40.66,61.58Z"
        }), /*#__PURE__*/_jsx("path", {
          d: "M68.2,79.48v0.18A3.29,3.29,0,0,0,69,81.79l0.71,0.88-1.76,1a3.29,3.29,0,0,0-1.65,2.85v1.07h1V86.54a2.24,2.24,0,0,1,1.12-1.94l1.76-1A1.08,1.08,0,0,0,70.5,82l-0.72-.85a2.23,2.23,0,0,1-.53-1.45V79.48a2.27,2.27,0,0,1,2.06-2.32,2.18,2.18,0,0,1,1.66.6,2.21,2.21,0,0,1,.7,1.62v0.28a2.23,2.23,0,0,1-.53,1.45L72.43,82a1.08,1.08,0,0,0,.28,1.63l1.76,1a2.24,2.24,0,0,1,1.12,1.94v1.07h1V86.54A3.28,3.28,0,0,0,75,83.69l-1.76-1.06,0.72-.84a3.29,3.29,0,0,0,.78-2.13V79.39a3.3,3.3,0,0,0-1-2.39,3.22,3.22,0,0,0-2.44-.88A3.33,3.33,0,0,0,68.2,79.48Z"
        }), /*#__PURE__*/_jsx("path", {
          d: "M75,39.45L73.22,38.4l0.72-.84a3.29,3.29,0,0,0,.78-2.13V35.15a3.3,3.3,0,0,0-1-2.39,3.22,3.22,0,0,0-2.44-.88,3.33,3.33,0,0,0-3,3.36v0.18A3.29,3.29,0,0,0,69,37.55l0.71,0.88-1.76,1a3.29,3.29,0,0,0-1.65,2.85v1.07h1V42.3a2.24,2.24,0,0,1,1.12-1.94l1.76-1a1.08,1.08,0,0,0,.28-1.63l-0.72-.85a2.23,2.23,0,0,1-.53-1.45V35.24a2.27,2.27,0,0,1,2.06-2.32,2.18,2.18,0,0,1,1.66.6,2.21,2.21,0,0,1,.7,1.62v0.28a2.23,2.23,0,0,1-.53,1.45l-0.72.85a1.08,1.08,0,0,0,.28,1.63l1.76,1a2.24,2.24,0,0,1,1.12,1.94v1.07h1V42.3A3.28,3.28,0,0,0,75,39.45Z"
        })]
      }));

    case 'chart':
      return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, svgProps), {}, {
        viewBox: "0 0 119 119",
        children: [/*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          d: "M59.5,0A59.5,59.5,0,1,0,119,59.5,59.57,59.57,0,0,0,59.5,0Zm0,115A55.5,55.5,0,1,1,115,59.5,55.56,55.56,0,0,1,59.5,115Z"
        }), /*#__PURE__*/_jsx("rect", {
          x: "77.41",
          y: "55.21",
          width: "2.56",
          height: "34.61"
        }), /*#__PURE__*/_jsx("rect", {
          x: "67.19",
          y: "62.9",
          width: "2.56",
          height: "26.92"
        }), /*#__PURE__*/_jsx("rect", {
          x: "56.97",
          y: "75.72",
          width: "2.56",
          height: "14.1"
        }), /*#__PURE__*/_jsx("rect", {
          x: "46.74",
          y: "72.52",
          width: "2.56",
          height: "17.3"
        }), /*#__PURE__*/_jsx("rect", {
          x: "36.52",
          y: "83.41",
          width: "2.56",
          height: "6.41"
        }), /*#__PURE__*/_jsx("polygon", {
          fillRule: "evenodd",
          points: "73.21 41.97 57.45 60.48 47.55 52.01 35.24 66.46 36.91 67.89 47.8 55.1 57.69 63.58 74.88 43.4 78.91 46.85 81.25 34.22 69.17 38.51 73.21 41.97"
        })]
      }));

    case 'chevron-carousel':
      return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, svgProps), {}, {
        viewBox: "0 0 119 119",
        children: /*#__PURE__*/_jsx("polyline", {
          className: "cls-1",
          points: "0.71 0.71 15.71 15.71 0.71 30.71"
        })
      }));

    case 'x':
      return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, svgProps), {}, {
        viewBox: "0 0 16 16",
        children: /*#__PURE__*/_jsx("path", {
          d: "M14.354 2.353l-.708-.707L8 7.293 2.353 1.646l-.707.707L7.293 8l-5.647 5.646.707.708L8 8.707l5.646 5.647.708-.708L8.707 8z"
        })
      }));

    case 'check-alt':
      return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, svgProps), {}, {
        viewBox: "0 0 32 32",
        children: /*#__PURE__*/_jsx("path", {
          d: "M11.999 22.693l-5.122-5.997-.658.77 5.78 6.767L24.756 9.296l-.76-.649-11.997 14.046zM15.5 0C6.94 0 0 6.939 0 15.5 0 24.06 6.94 31 15.5 31S31 24.06 31 15.5C31 6.939 24.06 0 15.5 0zm0 30C7.505 30 1 23.495 1 15.5S7.505 1 15.5 1 30 7.505 30 15.5 23.495 30 15.5 30z"
        })
      }));

    default:
      return null;
  }
}